import { render, staticRenderFns } from "./UnilevelSettings.vue?vue&type=template&id=04daa10c"
import script from "./UnilevelSettings.vue?vue&type=script&lang=js"
export * from "./UnilevelSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports